module.exports = __webpack_public_path__ + "static/media/other-img-3.1570ba92.png";